Pegasus.HelpIndicatorView = Em.View.extend({
  templateName: 'help_indicator',
  classNames: ['gps-wrapper'],
  click: function(){
    this.$().addClass('clicked');
    Em.run.later( this, function(){
      this.get('controller').send('dismissHelpContext');
      this.rerender();
    }, 300);
    return false;
  },
  didInsertElement: function(){
    this._super();
    var controller = this.get('controller');

    $(window).on('click.' + this.get('elementId'), function(){
      Em.run( controller, 'send', 'setHelpContext', 'idling');
    });
  },
  willDestroyElement: function(){
    $(window).off('click.' + this.get('elementId'));
    this._super();
  }
});
